import { statusEnumSQ } from '../enums/statusEnumSQ'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

export const getDeclaredLanguages = (languageAbility) => {
  if (!Array.isArray(languageAbility)) return ''

  return languageAbility
    .map(({ value, additionalInfo }) => (value === 'Other Language' ? additionalInfo : value))
    .filter(Boolean)
    .join(', ')
}

const formatDataForTable = (item) => [
    item.applicant.firstName,
    item.applicant.lastName,
    item.applicant.email ? item.applicant.email : item.applicant.personal_email,
    item.applicant.position,
    item.applicant.office_location,
    getDeclaredLanguages(item.applicant.languageAbility),
    `${moment(item?.applicant.created_at).format('LLL')}`,
    { status: statusEnumSQ[item?.applicant.status], statusKey: item?.applicant.status, blacklistMatch: item?.applicant.blacklist_match, blacklistMatchDismissed: item?.applicant.blacklist_match_dismissed, exEmployee: item?.applicant.ex_employee, exEmployeeDismissed: item?.applicant.ex_employee_dismissed, interview_date: item?.applicant?.interview_date },
    <Link to={`/applicants/${item.applicant._id}`}>
      <Button color='success' size='sm'>
        More
      </Button>
    </Link>
  ]

export default formatDataForTable
